import { memo } from "react";

import { modules } from "byzantine";
import { Localized } from "@fluent/react";
import { LoadingShim } from "@narmi/design_system";

import styles from "../../SearchBar.module.scss";
import { useSearchBar } from "../../context";

import {
  AccountsResults,
  PagesResults,
  TransactionsResults,
} from "./SearchBarResults.Sections";

const { useIsGlobalSearchEnabled } = modules.search;

const SearchBarResults = () => {
  const { loading, noResultsFound } = useSearchBar();
  const { enabledSearchEntities } = useIsGlobalSearchEnabled();

  return (
    <div className={styles["results-loading-shim"]}>
      <LoadingShim isLoading={loading} size="s">
        <div className={styles["results-section-container"]}>
          {noResultsFound && !loading ? (
            <Localized id="search-bar-results-no-matches" />
          ) : (
            <>
              {enabledSearchEntities.transactions && <TransactionsResults />}
              {enabledSearchEntities.accounts && <AccountsResults />}
              {enabledSearchEntities.pages && <PagesResults />}
            </>
          )}
        </div>
      </LoadingShim>
    </div>
  );
};

export default memo(SearchBarResults);
